import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Category = /*#__PURE__*/function (Category) {
  Category[Category["CATEGORY_INVALID"] = 0] = "CATEGORY_INVALID";
  Category[Category["CATEGORY_WEBSITE"] = 1] = "CATEGORY_WEBSITE";
  Category[Category["CATEGORY_ADINTEL"] = 2] = "CATEGORY_ADINTEL";
  Category[Category["CATEGORY_ALL"] = 3] = "CATEGORY_ALL";
  return Category;
}(Category || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var StatAggregation = /*#__PURE__*/function (StatAggregation) {
  StatAggregation[StatAggregation["STAT_AGGREGATION_UNSET"] = 0] = "STAT_AGGREGATION_UNSET";
  StatAggregation[StatAggregation["STAT_AGGREGATION_DAILY"] = 1] = "STAT_AGGREGATION_DAILY";
  StatAggregation[StatAggregation["STAT_AGGREGATION_WEEKLY"] = 2] = "STAT_AGGREGATION_WEEKLY";
  StatAggregation[StatAggregation["STAT_AGGREGATION_MONTHLY"] = 3] = "STAT_AGGREGATION_MONTHLY";
  return StatAggregation;
}(StatAggregation || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ConnectedProperty {
  static fromProto(proto) {
    let m = new ConnectedProperty();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue$3(Category, proto.category);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.subcategory !== 'undefined') {
      toReturn['subcategory'] = this.subcategory;
    }
    if (typeof this.propertyId !== 'undefined') {
      toReturn['propertyId'] = this.propertyId;
    }
    if (typeof this.propertyName !== 'undefined') {
      toReturn['propertyName'] = this.propertyName;
    }
    if (typeof this.accountName !== 'undefined') {
      toReturn['accountName'] = this.accountName;
    }
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    if (typeof this.googleUserId !== 'undefined') {
      toReturn['googleUserId'] = this.googleUserId;
    }
    if (typeof this.isBroken !== 'undefined') {
      toReturn['isBroken'] = this.isBroken;
    }
    if (typeof this.campaigns !== 'undefined') {
      toReturn['campaigns'] = this.campaigns;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    return toReturn;
  }
}
class DeletePropertyRequest {
  static fromProto(proto) {
    let m = new DeletePropertyRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue$3(Category, proto.category);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.subcategory !== 'undefined') {
      toReturn['subcategory'] = this.subcategory;
    }
    return toReturn;
  }
}
class GetAvailablePropertiesRequest {
  static fromProto(proto) {
    let m = new GetAvailablePropertiesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.googleUserId !== 'undefined') {
      toReturn['googleUserId'] = this.googleUserId;
    }
    return toReturn;
  }
}
class GetAvailablePropertiesResponse {
  static fromProto(proto) {
    let m = new GetAvailablePropertiesResponse();
    m = Object.assign(m, proto);
    if (proto.properties) {
      m.properties = proto.properties.map(ConnectedProperty.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.properties !== 'undefined' && this.properties !== null) {
      toReturn['properties'] = 'toApiJson' in this.properties ? this.properties.toApiJson() : this.properties;
    }
    return toReturn;
  }
}
class GetCampaignInfoForPropertyRequest {
  static fromProto(proto) {
    let m = new GetCampaignInfoForPropertyRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue$3(Category, proto.category);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.subcategory !== 'undefined') {
      toReturn['subcategory'] = this.subcategory;
    }
    if (typeof this.propertyId !== 'undefined') {
      toReturn['propertyId'] = this.propertyId;
    }
    if (typeof this.googleUserId !== 'undefined') {
      toReturn['googleUserId'] = this.googleUserId;
    }
    return toReturn;
  }
}
class GetCampaignInfoForPropertyResponse {
  static fromProto(proto) {
    let m = new GetCampaignInfoForPropertyResponse();
    m = Object.assign(m, proto);
    if (proto.campaignInfo) {
      m.campaignInfo = proto.campaignInfo.map(PropertyCampaignInfo.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignInfo !== 'undefined' && this.campaignInfo !== null) {
      toReturn['campaignInfo'] = 'toApiJson' in this.campaignInfo ? this.campaignInfo.toApiJson() : this.campaignInfo;
    }
    return toReturn;
  }
}
class GetPropertyRequest {
  static fromProto(proto) {
    let m = new GetPropertyRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue$3(Category, proto.category);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.subcategory !== 'undefined') {
      toReturn['subcategory'] = this.subcategory;
    }
    return toReturn;
  }
}
class GetPropertyResponse {
  static fromProto(proto) {
    let m = new GetPropertyResponse();
    m = Object.assign(m, proto);
    if (proto.property) {
      m.property = ConnectedProperty.fromProto(proto.property);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.property !== 'undefined' && this.property !== null) {
      toReturn['property'] = 'toApiJson' in this.property ? this.property.toApiJson() : this.property;
    }
    return toReturn;
  }
}
class LookupPropertiesRequest {
  static fromProto(proto) {
    let m = new LookupPropertiesRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue$3(Category, proto.category);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class LookupPropertiesResponse {
  static fromProto(proto) {
    let m = new LookupPropertiesResponse();
    m = Object.assign(m, proto);
    if (proto.properties) {
      m.properties = proto.properties.map(ConnectedProperty.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.properties !== 'undefined' && this.properties !== null) {
      toReturn['properties'] = 'toApiJson' in this.properties ? this.properties.toApiJson() : this.properties;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class PropertyCampaignInfo {
  static fromProto(proto) {
    let m = new PropertyCampaignInfo();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.campaignName !== 'undefined') {
      toReturn['campaignName'] = this.campaignName;
    }
    return toReturn;
  }
}
class SetPropertyMultiRequest {
  static fromProto(proto) {
    let m = new SetPropertyMultiRequest();
    m = Object.assign(m, proto);
    if (proto.properties) {
      m.properties = proto.properties.map(ConnectedProperty.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.properties !== 'undefined' && this.properties !== null) {
      toReturn['properties'] = 'toApiJson' in this.properties ? this.properties.toApiJson() : this.properties;
    }
    return toReturn;
  }
}
class UpdatePropertyRequest {
  static fromProto(proto) {
    let m = new UpdatePropertyRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue$3(Category, proto.category);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.subcategory !== 'undefined') {
      toReturn['subcategory'] = this.subcategory;
    }
    if (typeof this.campaigns !== 'undefined') {
      toReturn['campaigns'] = this.campaigns;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ConnectedView {
  static fromProto(proto) {
    let m = new ConnectedView();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.subcategory !== 'undefined') {
      toReturn['subcategory'] = this.subcategory;
    }
    if (typeof this.gaViewId !== 'undefined') {
      toReturn['gaViewId'] = this.gaViewId;
    }
    if (typeof this.gaViewName !== 'undefined') {
      toReturn['gaViewName'] = this.gaViewName;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.isBroken !== 'undefined') {
      toReturn['isBroken'] = this.isBroken;
    }
    if (typeof this.campaigns !== 'undefined') {
      toReturn['campaigns'] = this.campaigns;
    }
    return toReturn;
  }
}
class View {
  static fromProto(proto) {
    let m = new View();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.gaViewName !== 'undefined') {
      toReturn['gaViewName'] = this.gaViewName;
    }
    if (typeof this.gaViewId !== 'undefined') {
      toReturn['gaViewId'] = this.gaViewId;
    }
    if (typeof this.gaAccountName !== 'undefined') {
      toReturn['gaAccountName'] = this.gaAccountName;
    }
    if (typeof this.gaAccountId !== 'undefined') {
      toReturn['gaAccountId'] = this.gaAccountId;
    }
    if (typeof this.gaWebPropertyName !== 'undefined') {
      toReturn['gaWebPropertyName'] = this.gaWebPropertyName;
    }
    if (typeof this.gaWebPropertyId !== 'undefined') {
      toReturn['gaWebPropertyId'] = this.gaWebPropertyId;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Attribute {
  static fromProto(proto) {
    let m = new Attribute();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class GetViewStatsResponseCampaignStatsEntry {
  static fromProto(proto) {
    let m = new GetViewStatsResponseCampaignStatsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = StatsSet.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class GetCampaignInfoForViewResponseCampaignsEntry {
  static fromProto(proto) {
    let m = new GetCampaignInfoForViewResponseCampaignsEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class DataPoint {
  static fromProto(proto) {
    let m = new DataPoint();
    m = Object.assign(m, proto);
    if (proto.name) {
      m.name = new Date(proto.name);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined' && this.name !== null) {
      toReturn['name'] = 'toApiJson' in this.name ? this.name.toApiJson() : this.name;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class DataSet {
  static fromProto(proto) {
    let m = new DataSet();
    m = Object.assign(m, proto);
    if (proto.series) {
      m.series = proto.series.map(DataPoint.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.series !== 'undefined' && this.series !== null) {
      toReturn['series'] = 'toApiJson' in this.series ? this.series.toApiJson() : this.series;
    }
    return toReturn;
  }
}
class GetCampaignInfoForViewRequest {
  static fromProto(proto) {
    let m = new GetCampaignInfoForViewRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue$1(Category, proto.category);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.subcategory !== 'undefined') {
      toReturn['subcategory'] = this.subcategory;
    }
    if (typeof this.viewId !== 'undefined') {
      toReturn['viewId'] = this.viewId;
    }
    if (typeof this.googleUserId !== 'undefined') {
      toReturn['googleUserId'] = this.googleUserId;
    }
    return toReturn;
  }
}
class GetCampaignInfoForViewResponse {
  static fromProto(proto) {
    let m = new GetCampaignInfoForViewResponse();
    m = Object.assign(m, proto);
    if (proto.campaigns) {
      m.campaigns = Object.keys(proto.campaigns).reduce((obj, k) => {
        obj[k] = proto.campaigns[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaigns !== 'undefined' && this.campaigns !== null) {
      toReturn['campaigns'] = 'toApiJson' in this.campaigns ? this.campaigns.toApiJson() : this.campaigns;
    }
    return toReturn;
  }
}
class GetHistoricalPropertyStatsRequest {
  static fromProto(proto) {
    let m = new GetHistoricalPropertyStatsRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue$1(Category, proto.category);
    }
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    if (proto.aggregation) {
      m.aggregation = enumStringToValue$1(StatAggregation, proto.aggregation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.subcategories !== 'undefined') {
      toReturn['subcategories'] = this.subcategories;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    if (typeof this.aggregation !== 'undefined') {
      toReturn['aggregation'] = this.aggregation;
    }
    if (typeof this.stats !== 'undefined') {
      toReturn['stats'] = this.stats;
    }
    if (typeof this.bypassCache !== 'undefined') {
      toReturn['bypassCache'] = this.bypassCache;
    }
    return toReturn;
  }
}
class GetHistoricalPropertyStatsResponse {
  static fromProto(proto) {
    let m = new GetHistoricalPropertyStatsResponse();
    m = Object.assign(m, proto);
    if (proto.stats) {
      m.stats = proto.stats.map(HistoricalStats.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stats !== 'undefined' && this.stats !== null) {
      toReturn['stats'] = 'toApiJson' in this.stats ? this.stats.toApiJson() : this.stats;
    }
    return toReturn;
  }
}
class GetPropertyStatsRequest {
  static fromProto(proto) {
    let m = new GetPropertyStatsRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue$1(Category, proto.category);
    }
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.subcategory !== 'undefined') {
      toReturn['subcategory'] = this.subcategory;
    }
    if (typeof this.dimensions !== 'undefined') {
      toReturn['dimensions'] = this.dimensions;
    }
    if (typeof this.stats !== 'undefined') {
      toReturn['stats'] = this.stats;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    if (typeof this.bypassCache !== 'undefined') {
      toReturn['bypassCache'] = this.bypassCache;
    }
    return toReturn;
  }
}
class GetPropertyStatsResponse {
  static fromProto(proto) {
    let m = new GetPropertyStatsResponse();
    m = Object.assign(m, proto);
    if (proto.stats) {
      m.stats = proto.stats.map(StatRow.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stats !== 'undefined' && this.stats !== null) {
      toReturn['stats'] = 'toApiJson' in this.stats ? this.stats.toApiJson() : this.stats;
    }
    return toReturn;
  }
}
class GetSourceMediumStatsForCampaignRequest {
  static fromProto(proto) {
    let m = new GetSourceMediumStatsForCampaignRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue$1(Category, proto.category);
    }
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.subcategory !== 'undefined') {
      toReturn['subcategory'] = this.subcategory;
    }
    if (typeof this.campaign !== 'undefined') {
      toReturn['campaign'] = this.campaign;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    return toReturn;
  }
}
class GetSourceMediumStatsForCampaignResponse {
  static fromProto(proto) {
    let m = new GetSourceMediumStatsForCampaignResponse();
    m = Object.assign(m, proto);
    if (proto.sourceMediumStats) {
      m.sourceMediumStats = Object.keys(proto.sourceMediumStats).reduce((obj, k) => {
        obj[k] = StatsSet.fromProto(proto.sourceMediumStats[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceMediumStats !== 'undefined' && this.sourceMediumStats !== null) {
      toReturn['sourceMediumStats'] = 'toApiJson' in this.sourceMediumStats ? this.sourceMediumStats.toApiJson() : this.sourceMediumStats;
    }
    return toReturn;
  }
}
class GetViewStatsRequest {
  static fromProto(proto) {
    let m = new GetViewStatsRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue$1(Category, proto.category);
    }
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.subcategory !== 'undefined') {
      toReturn['subcategory'] = this.subcategory;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    return toReturn;
  }
}
class GetViewStatsResponse {
  static fromProto(proto) {
    let m = new GetViewStatsResponse();
    m = Object.assign(m, proto);
    if (proto.totals) {
      m.totals = StatsSet.fromProto(proto.totals);
    }
    if (proto.campaignStats) {
      m.campaignStats = Object.keys(proto.campaignStats).reduce((obj, k) => {
        obj[k] = StatsSet.fromProto(proto.campaignStats[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.totals !== 'undefined' && this.totals !== null) {
      toReturn['totals'] = 'toApiJson' in this.totals ? this.totals.toApiJson() : this.totals;
    }
    if (typeof this.campaignStats !== 'undefined' && this.campaignStats !== null) {
      toReturn['campaignStats'] = 'toApiJson' in this.campaignStats ? this.campaignStats.toApiJson() : this.campaignStats;
    }
    return toReturn;
  }
}
class StatsSetGoalBreakdownEntry {
  static fromProto(proto) {
    let m = new StatsSetGoalBreakdownEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class HistoricalStats {
  static fromProto(proto) {
    let m = new HistoricalStats();
    m = Object.assign(m, proto);
    if (proto.values) {
      m.values = DataSet.fromProto(proto.values);
    }
    if (proto.total) {
      m.total = Stat.fromProto(proto.total);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.propertyId !== 'undefined') {
      toReturn['propertyId'] = this.propertyId;
    }
    if (typeof this.values !== 'undefined' && this.values !== null) {
      toReturn['values'] = 'toApiJson' in this.values ? this.values.toApiJson() : this.values;
    }
    if (typeof this.total !== 'undefined' && this.total !== null) {
      toReturn['total'] = 'toApiJson' in this.total ? this.total.toApiJson() : this.total;
    }
    return toReturn;
  }
}
class GetSourceMediumStatsForCampaignResponseSourceMediumStatsEntry {
  static fromProto(proto) {
    let m = new GetSourceMediumStatsForCampaignResponseSourceMediumStatsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = StatsSet.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class Stat {
  static fromProto(proto) {
    let m = new Stat();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class StatRow {
  static fromProto(proto) {
    let m = new StatRow();
    m = Object.assign(m, proto);
    if (proto.attributes) {
      m.attributes = proto.attributes.map(Attribute.fromProto);
    }
    if (proto.stats) {
      m.stats = proto.stats.map(Stat.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    if (typeof this.stats !== 'undefined' && this.stats !== null) {
      toReturn['stats'] = 'toApiJson' in this.stats ? this.stats.toApiJson() : this.stats;
    }
    return toReturn;
  }
}
class StatsSet {
  static fromProto(proto) {
    let m = new StatsSet();
    m = Object.assign(m, proto);
    if (proto.sessions) {
      m.sessions = parseInt(proto.sessions, 10);
    }
    if (proto.users) {
      m.users = parseInt(proto.users, 10);
    }
    if (proto.newUsers) {
      m.newUsers = parseInt(proto.newUsers, 10);
    }
    if (proto.goalCompletions) {
      m.goalCompletions = parseInt(proto.goalCompletions, 10);
    }
    if (proto.goalBreakdown) {
      m.goalBreakdown = Object.keys(proto.goalBreakdown).reduce((obj, k) => {
        obj[k] = parseInt(proto.goalBreakdown[k], 10);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sessions !== 'undefined') {
      toReturn['sessions'] = this.sessions;
    }
    if (typeof this.users !== 'undefined') {
      toReturn['users'] = this.users;
    }
    if (typeof this.newUsers !== 'undefined') {
      toReturn['newUsers'] = this.newUsers;
    }
    if (typeof this.bounceRate !== 'undefined') {
      toReturn['bounceRate'] = this.bounceRate;
    }
    if (typeof this.pageViewsPerSession !== 'undefined') {
      toReturn['pageViewsPerSession'] = this.pageViewsPerSession;
    }
    if (typeof this.averageSessionSeconds !== 'undefined') {
      toReturn['averageSessionSeconds'] = this.averageSessionSeconds;
    }
    if (typeof this.goalCompletions !== 'undefined') {
      toReturn['goalCompletions'] = this.goalCompletions;
    }
    if (typeof this.goalBreakdown !== 'undefined' && this.goalBreakdown !== null) {
      toReturn['goalBreakdown'] = 'toApiJson' in this.goalBreakdown ? this.goalBreakdown.toApiJson() : this.goalBreakdown;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CollectRecordsRequest {
  static fromProto(proto) {
    let m = new CollectRecordsRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue(Category, proto.category);
    }
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.subcategory !== 'undefined') {
      toReturn['subcategory'] = this.subcategory;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    return toReturn;
  }
}
class CollectRecordsResponse {
  static fromProto(proto) {
    let m = new CollectRecordsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.success !== 'undefined') {
      toReturn['success'] = this.success;
    }
    return toReturn;
  }
}
class DeleteViewRequest {
  static fromProto(proto) {
    let m = new DeleteViewRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue(Category, proto.category);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.subcategory !== 'undefined') {
      toReturn['subcategory'] = this.subcategory;
    }
    return toReturn;
  }
}
class DeleteViewResponse {
  static fromProto(proto) {
    let m = new DeleteViewResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.success !== 'undefined') {
      toReturn['success'] = this.success;
    }
    return toReturn;
  }
}
class GetAvailableGAViewsRequest {
  static fromProto(proto) {
    let m = new GetAvailableGAViewsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.googleUserId !== 'undefined') {
      toReturn['googleUserId'] = this.googleUserId;
    }
    return toReturn;
  }
}
class GetAvailableGAViewsResponse {
  static fromProto(proto) {
    let m = new GetAvailableGAViewsResponse();
    m = Object.assign(m, proto);
    if (proto.views) {
      m.views = proto.views.map(View.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.views !== 'undefined' && this.views !== null) {
      toReturn['views'] = 'toApiJson' in this.views ? this.views.toApiJson() : this.views;
    }
    return toReturn;
  }
}
class GetViewRequest {
  static fromProto(proto) {
    let m = new GetViewRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue(Category, proto.category);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.subcategory !== 'undefined') {
      toReturn['subcategory'] = this.subcategory;
    }
    return toReturn;
  }
}
class GetViewResponse {
  static fromProto(proto) {
    let m = new GetViewResponse();
    m = Object.assign(m, proto);
    if (proto.view) {
      m.view = View.fromProto(proto.view);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.view !== 'undefined' && this.view !== null) {
      toReturn['view'] = 'toApiJson' in this.view ? this.view.toApiJson() : this.view;
    }
    return toReturn;
  }
}
class LookupViewsRequest {
  static fromProto(proto) {
    let m = new LookupViewsRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue(Category, proto.category);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class LookupViewsResponse {
  static fromProto(proto) {
    let m = new LookupViewsResponse();
    m = Object.assign(m, proto);
    if (proto.views) {
      m.views = proto.views.map(ConnectedView.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.views !== 'undefined' && this.views !== null) {
      toReturn['views'] = 'toApiJson' in this.views ? this.views.toApiJson() : this.views;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class SetViewMultiRequest {
  static fromProto(proto) {
    let m = new SetViewMultiRequest();
    m = Object.assign(m, proto);
    if (proto.requests) {
      m.requests = proto.requests.map(SetViewRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.requests !== 'undefined' && this.requests !== null) {
      toReturn['requests'] = 'toApiJson' in this.requests ? this.requests.toApiJson() : this.requests;
    }
    return toReturn;
  }
}
class SetViewRequest {
  static fromProto(proto) {
    let m = new SetViewRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue(Category, proto.category);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.subcategory !== 'undefined') {
      toReturn['subcategory'] = this.subcategory;
    }
    if (typeof this.gaAccountId !== 'undefined') {
      toReturn['gaAccountId'] = this.gaAccountId;
    }
    if (typeof this.gaPropertyId !== 'undefined') {
      toReturn['gaPropertyId'] = this.gaPropertyId;
    }
    if (typeof this.gaViewId !== 'undefined') {
      toReturn['gaViewId'] = this.gaViewId;
    }
    if (typeof this.googleUserId !== 'undefined') {
      toReturn['googleUserId'] = this.googleUserId;
    }
    if (typeof this.campaigns !== 'undefined') {
      toReturn['campaigns'] = this.campaigns;
    }
    return toReturn;
  }
}
class SetViewResponse {
  static fromProto(proto) {
    let m = new SetViewResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.success !== 'undefined') {
      toReturn['success'] = this.success;
    }
    return toReturn;
  }
}
class UpdateViewRequest {
  static fromProto(proto) {
    let m = new UpdateViewRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue(Category, proto.category);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.subcategory !== 'undefined') {
      toReturn['subcategory'] = this.subcategory;
    }
    if (typeof this.campaigns !== 'undefined') {
      toReturn['campaigns'] = this.campaigns;
    }
    return toReturn;
  }
}
class UpdateViewResponse {
  static fromProto(proto) {
    let m = new UpdateViewResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.success !== 'undefined') {
      toReturn['success'] = this.success;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'google-analytics-api.vendasta-local.com',
  'test': '',
  'demo': 'google-analytics-api-demo.apigateway.co',
  'prod': 'google-analytics-api-prod.apigateway.co',
  'production': 'google-analytics-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ViewsApiService = /*#__PURE__*/(() => {
  class ViewsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getView(r) {
      const request = r.toApiJson ? r : new GetViewRequest(r);
      return this.http.post(this._host + "/googleanalytics.v2.Views/GetView", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetViewResponse.fromProto(resp)));
    }
    setView(r) {
      const request = r.toApiJson ? r : new SetViewRequest(r);
      return this.http.post(this._host + "/googleanalytics.v2.Views/SetView", request.toApiJson(), this.apiOptions()).pipe(map(resp => SetViewResponse.fromProto(resp)));
    }
    deleteView(r) {
      const request = r.toApiJson ? r : new DeleteViewRequest(r);
      return this.http.post(this._host + "/googleanalytics.v2.Views/DeleteView", request.toApiJson(), this.apiOptions()).pipe(map(resp => DeleteViewResponse.fromProto(resp)));
    }
    lookupViews(r) {
      const request = r.toApiJson ? r : new LookupViewsRequest(r);
      return this.http.post(this._host + "/googleanalytics.v2.Views/LookupViews", request.toApiJson(), this.apiOptions()).pipe(map(resp => LookupViewsResponse.fromProto(resp)));
    }
    getAvailableViews(r) {
      const request = r.toApiJson ? r : new GetAvailableGAViewsRequest(r);
      return this.http.post(this._host + "/googleanalytics.v2.Views/GetAvailableViews", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAvailableGAViewsResponse.fromProto(resp)));
    }
    setViewMulti(r) {
      const request = r.toApiJson ? r : new SetViewMultiRequest(r);
      return this.http.post(this._host + "/googleanalytics.v2.Views/SetViewMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => SetViewResponse.fromProto(resp)));
    }
    updateView(r) {
      const request = r.toApiJson ? r : new UpdateViewRequest(r);
      return this.http.post(this._host + "/googleanalytics.v2.Views/UpdateView", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateViewResponse.fromProto(resp)));
    }
  }
  ViewsApiService.ɵfac = function ViewsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ViewsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ViewsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ViewsApiService,
    factory: ViewsApiService.ɵfac,
    providedIn: 'root'
  });
  return ViewsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ViewService = /*#__PURE__*/(() => {
  class ViewService {
    constructor(api) {
      this.api = api;
    }
    getConnectedView(partnerId, businessId, category, subcategory) {
      return this.api.getView({
        partnerId: partnerId,
        businessId: businessId,
        category: category,
        subcategory: subcategory
      }).pipe(map(resp => resp.view));
    }
    lookupViews(partnerId, businessId, category, cursor) {
      return this.api.lookupViews({
        partnerId: partnerId,
        businessId: businessId,
        category: category,
        cursor: cursor
      });
    }
    getAvailableViews(googleUserId) {
      return this.api.getAvailableViews({
        googleUserId: googleUserId
      }).pipe(map(resp => resp.views));
    }
    setView(req) {
      return this.api.setView(req).pipe(map(resp => resp.success));
    }
    deleteView(partnerId, businessId, category, subcategory) {
      return this.api.deleteView({
        partnerId,
        businessId,
        category,
        subcategory
      }).pipe(map(resp => resp.success));
    }
  }
  ViewService.ɵfac = function ViewService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ViewService)(i0.ɵɵinject(ViewsApiService));
  };
  ViewService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ViewService,
    factory: ViewService.ɵfac,
    providedIn: 'root'
  });
  return ViewService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let StatsApiService = /*#__PURE__*/(() => {
  class StatsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getCampaignInfoForView(r) {
      const request = r.toApiJson ? r : new GetCampaignInfoForViewRequest(r);
      return this.http.post(this._host + "/googleanalytics.v2.Stats/GetCampaignInfoForView", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCampaignInfoForViewResponse.fromProto(resp)));
    }
    getViewStats(r) {
      const request = r.toApiJson ? r : new GetViewStatsRequest(r);
      return this.http.post(this._host + "/googleanalytics.v2.Stats/GetViewStats", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetViewStatsResponse.fromProto(resp)));
    }
    getSourceMediumStatsForCampaign(r) {
      const request = r.toApiJson ? r : new GetSourceMediumStatsForCampaignRequest(r);
      return this.http.post(this._host + "/googleanalytics.v2.Stats/GetSourceMediumStatsForCampaign", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSourceMediumStatsForCampaignResponse.fromProto(resp)));
    }
    getPropertyStats(r) {
      const request = r.toApiJson ? r : new GetPropertyStatsRequest(r);
      return this.http.post(this._host + "/googleanalytics.v2.Stats/GetPropertyStats", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPropertyStatsResponse.fromProto(resp)));
    }
    getHistoricalPropertyStats(r) {
      const request = r.toApiJson ? r : new GetHistoricalPropertyStatsRequest(r);
      return this.http.post(this._host + "/googleanalytics.v2.Stats/GetHistoricalPropertyStats", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetHistoricalPropertyStatsResponse.fromProto(resp)));
    }
  }
  StatsApiService.ɵfac = function StatsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || StatsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  StatsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: StatsApiService,
    factory: StatsApiService.ɵfac,
    providedIn: 'root'
  });
  return StatsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let GA4PropertiesApiService = /*#__PURE__*/(() => {
  class GA4PropertiesApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getProperty(r) {
      const request = r.toApiJson ? r : new GetPropertyRequest(r);
      return this.http.post(this._host + "/googleanalytics.v2.GA4Properties/GetProperty", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPropertyResponse.fromProto(resp)));
    }
    setPropertyMulti(r) {
      const request = r.toApiJson ? r : new SetPropertyMultiRequest(r);
      return this.http.post(this._host + "/googleanalytics.v2.GA4Properties/SetPropertyMulti", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteProperty(r) {
      const request = r.toApiJson ? r : new DeletePropertyRequest(r);
      return this.http.post(this._host + "/googleanalytics.v2.GA4Properties/DeleteProperty", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    lookupProperties(r) {
      const request = r.toApiJson ? r : new LookupPropertiesRequest(r);
      return this.http.post(this._host + "/googleanalytics.v2.GA4Properties/LookupProperties", request.toApiJson(), this.apiOptions()).pipe(map(resp => LookupPropertiesResponse.fromProto(resp)));
    }
    getAvailableProperties(r) {
      const request = r.toApiJson ? r : new GetAvailablePropertiesRequest(r);
      return this.http.post(this._host + "/googleanalytics.v2.GA4Properties/GetAvailableProperties", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAvailablePropertiesResponse.fromProto(resp)));
    }
    updateProperty(r) {
      const request = r.toApiJson ? r : new UpdatePropertyRequest(r);
      return this.http.post(this._host + "/googleanalytics.v2.GA4Properties/UpdateProperty", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getCampaignInfoForProperty(r) {
      const request = r.toApiJson ? r : new GetCampaignInfoForPropertyRequest(r);
      return this.http.post(this._host + "/googleanalytics.v2.GA4Properties/GetCampaignInfoForProperty", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCampaignInfoForPropertyResponse.fromProto(resp)));
    }
  }
  GA4PropertiesApiService.ɵfac = function GA4PropertiesApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || GA4PropertiesApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  GA4PropertiesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: GA4PropertiesApiService,
    factory: GA4PropertiesApiService.ɵfac,
    providedIn: 'root'
  });
  return GA4PropertiesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Attribute, Category, CollectRecordsRequest, CollectRecordsResponse, ConnectedProperty, ConnectedView, DataPoint, DataSet, DeletePropertyRequest, DeleteViewRequest, DeleteViewResponse, GA4PropertiesApiService, GetAvailableGAViewsRequest, GetAvailableGAViewsResponse, GetAvailablePropertiesRequest, GetAvailablePropertiesResponse, GetCampaignInfoForPropertyRequest, GetCampaignInfoForPropertyResponse, GetCampaignInfoForViewRequest, GetCampaignInfoForViewResponse, GetCampaignInfoForViewResponseCampaignsEntry, GetHistoricalPropertyStatsRequest, GetHistoricalPropertyStatsResponse, GetPropertyRequest, GetPropertyResponse, GetPropertyStatsRequest, GetPropertyStatsResponse, GetSourceMediumStatsForCampaignRequest, GetSourceMediumStatsForCampaignResponse, GetSourceMediumStatsForCampaignResponseSourceMediumStatsEntry, GetViewRequest, GetViewResponse, GetViewStatsRequest, GetViewStatsResponse, GetViewStatsResponseCampaignStatsEntry, HistoricalStats, LookupPropertiesRequest, LookupPropertiesResponse, LookupViewsRequest, LookupViewsResponse, PropertyCampaignInfo, SetPropertyMultiRequest, SetViewMultiRequest, SetViewRequest, SetViewResponse, Stat, StatAggregation, StatRow, StatsApiService, StatsSet, StatsSetGoalBreakdownEntry, UpdatePropertyRequest, UpdateViewRequest, UpdateViewResponse, View, ViewService, ViewsApiService };
